import axios from "axios";
import { getHeaders } from "../utils/helper";
import endpoints from "./endpoints";


export const getCountryApi = async params => {
    const callResponse = await axios({
        url: endpoints.fetchCountryRms,
        method: "get",
        headers: getHeaders(),
        params,
    })
        .then(response => response.data)
        .catch(err => ({ status: 0, response: err.response, code: err.response.status }));

    return callResponse;
};

export const getStateApi = async params => {
    const callResponse = await axios({
        url: endpoints.fetchStateRms,
        method: "get",
        headers: getHeaders(),
        params,
    })
        .then(response => response.data)
        .catch(err => ({ status: 0, response: err.response, code: err.response.status }));

    return callResponse;
};

export const getCityApi = async params => {
    const callResponse = await axios({
        url: endpoints.fetchCityRms,
        method: "get",
        headers: getHeaders(),
        params,
    })
        .then(response => response.data)
        .catch(err => ({ status: 0, response: err.response, code: err.response.status }));

    return callResponse;
};